/**
 * Wait function, useful if you want to show a loading spinner for example
 * just add `await wait(ms)` where you want to wait
 *
 * @param  {number} ms the milliseconds you want to wait for
 */
export function wait(ms) {return new Promise(function(r) { setTimeout(r, ms)})};
